function o(r) {
  return function(e) {
    return {
      ...r(e),
      data: e,
      toJSON: () => e
    };
  };
}
const n = o(() => ({}));
function a(r, t = {}) {
  return {
    name: r.name,
    body: r.body,
    resolve: t.resolve ?? ((e) => e),
    hydrate: t.hydrate ?? ((e) => n(e)),
    get variables() {
      throw new Error("operation.variables is not value, just type");
    },
    get query() {
      throw new Error("operation.query is not value, just type");
    }
  };
}
export {
  o as a,
  a as c
};
